import '../styles/main.scss';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

import $ from 'jquery';
import moment from 'moment';
import './autoload/_bootstrap.js';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.nl';
import 'jquery-ui/ui/effect';

import Router from './util/Router';
import common from './routes/common';
import { responsiveCart } from './routes/responsiveCart';
import { responsiveMenu } from './routes/responsiveMenu';
import home from './routes/home';
import aboutUs from './routes/about';
import archiveData from './routes/archiveData';
import woocommerceCheckout from './routes/woocommerceCheckout';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPhoneAlt, faEnvelope, faPlus, faTrash, faBars, faTimes, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

// Prefer the live WP jQuery for inline onclick handlers and Bootstrap plugins
window.$ = window.jQuery || $;
window.moment = moment;

library.add(faPhoneAlt, faEnvelope, faPlus, faTrash, faBars, faTimes, faShoppingCart);
dom.watch();

const routes = new Router({
  common,
  home,
  aboutUs,
  archiveData,
  // soberwp controller class + WooCommerce shop body class
  archiveProductData: archiveData,
  woocommerceShop: archiveData,
  woocommerceCheckout,
  responsiveCart,
  responsiveMenu,
});

$(() => routes.loadEvents());
